import { FileType } from "types";

import {
  resizeFile,
  resolveImageDimensions,
} from "views/apps/paciente/ficha/historico/imageUpload/imageUploadHelpers";

import { EditorState, AtomicBlockUtils } from "draft-js";

import { criarArquivo } from "helpers";
import { setLoadingState } from "redux/actions";

const allowedImageMimes = [
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "image/gif",
  "image/webp",
];

const allowedDocumentsAndVideoMimes = [
  "application/pdf", //pdf
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlxs
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //docx
  "application/msword",
  "video/mp4",
  "video/mpeg",
  "video/webm",
];

type ISetSelectedFiles = React.Dispatch<React.SetStateAction<FileType[]>>;

export const handleGeneralFileUpload = (
  files: FileType[],
  setSelectedFiles: ISetSelectedFiles,
  selectedFiles: FileType[]
) => {
  var allFiles: FileType[] = [];

  for (const file of files) {
    if (allowedDocumentsAndVideoMimes.includes(file.type)) {
      allFiles.push(
        Object.assign(file, {
          formattedSize: formatBytes(file.size),
        })
      );
    }
  }

  setSelectedFiles([...selectedFiles, ...allFiles]);
};

const formatBytes = (bytes: number, decimals: number = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const removeFile = (
  fileIndex: number,
  selectedFiles: FileType[],
  setSelectedFiles: ISetSelectedFiles
) => {
  const newFiles = [...selectedFiles];
  newFiles.splice(fileIndex, 1);
  setSelectedFiles(newFiles);
};

export const handleImageUpload = async (
  files: Array<File>,
  editorState: EditorState,
  setEditorState: React.Dispatch<React.SetStateAction<EditorState>>,
  dispatch: any
) => {
  if (files.length) {
    const file = files[0];
    if (allowedImageMimes.includes(file.type)) {
      const [originalWidth, originalHeight] = await resolveImageDimensions(file);

      dispatch(setLoadingState(true));
      try {
        const {
          data: {
            arquivos: [newProfilePic],
          },
        } = await criarArquivo(files, "1", "", true);

        const [width, height] = resizeFile(originalWidth, originalHeight);

        const entityData = {
          src: newProfilePic.path,
          height,
          width,
          className: "test",
        };

        const entityKey = editorState
          .getCurrentContent()
          .createEntity("IMAGE", "MUTABLE", entityData)
          .getLastCreatedEntityKey();

        const newEditorState = AtomicBlockUtils.insertAtomicBlock(
          editorState,
          entityKey,
          " "
        );

        setEditorState(newEditorState);
      } catch (error) {
        console.log({ error });
      }
      dispatch(setLoadingState(false));
    }
  }
};

/**
 * Variante que insere a imagem usando uma URL local (blob:), sem upload.
 * Usada na tela de Comunicados, onde o upload real só ocorre no submit.
 */
export const handleImageUploadLocal = async (
  files: Array<File>,
  editorState: EditorState,
  setEditorState: (editorState: EditorState) => void,
  onFileSelected: (blobUrl: string, file: File) => void
) => {
  if (files.length) {
    const file = files[0];
    if (allowedImageMimes.includes(file.type)) {
      const [originalWidth, originalHeight] = await resolveImageDimensions(file);

      const [width, height] = resizeFile(originalWidth, originalHeight);
      const blobUrl = URL.createObjectURL(file);
      onFileSelected(blobUrl, file);

      const entityData = {
        src: blobUrl,
        height,
        width,
        className: "test",
      };

      const entityKey = editorState
        .getCurrentContent()
        .createEntity("IMAGE", "MUTABLE", entityData)
        .getLastCreatedEntityKey();

      const newEditorState = AtomicBlockUtils.insertAtomicBlock(
        editorState,
        entityKey,
        " "
      );

      setEditorState(newEditorState);
    }
  }
};
